import {axiosBaseInstance, axiosInstance} from '~/utils/axios-accessor'

import * as authorization from '~/api/authorization/authorization'
import * as aspOption from '~/api/authorization/aspOption'
import * as authorizationInfo from '~/api/authorization/authorizationInfo'
import * as getUserInfoByToken from '~/api/authorization/getUserInfoByToken'
import * as registration from '~/api/crmperson/registration'
import * as restorePassword from '~/api/crmperson/restorePassword'
import * as resetPassword from '~/api/crmperson/resetPassword'
import * as b2c from '~/api/crmperson/b2c'
import * as b2cSettings from '~/api/crmperson/b2cSettings'
import * as b2cKey from '~/api/crmperson/b2cKey'
import * as b2cPaymentMethods from '~/api/crmperson/b2cPaymentMethods'
import * as settings from '~/api/crmperson/settings'
import * as reportIssueInfo from '~/api/support/reportIssueInfo'
import * as locations from '~/api/locations/locations'
import * as locationPoints from '~/api/locations/locationPoints'
import * as restrictedLocations from '~/api/locations/restrictedLocations'
import * as contentProvidersLocations from '~/api/locations/contentProvidersLocations'

import * as fillAccommodationBookingData from '~/api/accommodations/fillAccommodationBookingData'
import * as hotelDescriptionCheckin from '~/api/accommodations/hotelDescriptionCheckin'
import * as hotelCategoryDictionaryInfo from '~/api/accommodations/hotelCategoryDictionaryInfo'
import * as hotelTypesDictionaryInfo from '~/api/accommodations/hotelTypesDictionaryInfo'
import * as hotelDescriptionLocation from '~/api/accommodations/hotelDescriptionLocation'
import * as ownHotelInfo from '~/api/accommodations/ownHotelInfo'
import * as copyHotelInfo from '~/api/accommodations/copyHotelInfo'
import * as hotelDescriptionAmenities from '~/api/accommodations/hotelDescriptionAmenities'
import * as hotelExtraServicesDictionaryInfo from '~/api/accommodations/hotelExtraServicesDictionaryInfo'
import * as hotelClassificationDictionaryInfo from '~/api/accommodations/hotelClassificationDictionaryInfo'
import * as hotelDescriptionGeneral from '~/api/accommodations/hotelDescriptionGeneral'
import * as hotelDescriptionDetails from '~/api/accommodations/hotelDescriptionDetails'
import * as hotelDescriptionMealType from '~/api/accommodations/hotelDescriptionMealType'
import * as hotelDescriptionImages from '~/api/accommodations/hotelDescriptionImages'
import * as hotelMealTypesDictionaryInfo from '~/api/accommodations/hotelMealTypesDictionaryInfo'
import * as hotelLocationDictionaryInfo from '~/api/accommodations/hotelLocationDictionaryInfo'
import * as hotelDescriptionRoomType from '~/api/accommodations/hotelDescriptionRoomType'
import * as hotelDescriptionRoomTypeSwap from '~/api/accommodations/hotelDescriptionRoomTypeSwap'
import * as searchAccommodation from '~/api/accommodations/searchAccommodation'
import * as partialSearchResults from '~/api/search/partialSearchResults'
import * as partialSearchStatus from '~/api/search/partialSearchStatus'
import * as suppliers from '~/api/search/suppliers'
import * as contentProviders from '~/api/search/contentProviders'
import * as hotelInfo from '~/api/accommodations/hotelInfo'
import * as hotelDictionaryInfo from '~/api/accommodations/hotelDictionaryInfo'
import * as hotelChainDictionaryInfo from '~/api/accommodations/hotelChainDictionaryInfo'
import * as hotelServiceDictionaryInfo from '~/api/accommodations/hotelServiceDictionaryInfo'
import * as hotelRoomDictionaryInfo from '~/api/accommodations/hotelRoomDictionaryInfo'
import * as hotelRoomAmenitiesTypes from '~/api/accommodations/hotelRoomAmenitiesTypes'
import * as hotelRoomAmenities from '~/api/accommodations/hotelRoomAmenities'
import * as hotelTags from '~/api/accommodations/hotelTags'
import * as hotels from '~/api/accommodations/hotels'
import * as conditions from '~/api/cancellation/conditions'
import * as cancelService from '~/api/cancellation/cancelService'
import * as currentCancelInfo from '~/api/cancellation/currentCancelInfo'
import * as paymentOptions from '~/api/booking/paymentOptions'
import * as prepareBookSaveOrder from '~/api/booking/prepareBookSaveOrder'
import * as paymentMethods from '~/api/booking/paymentMethods'
import * as paymentByLoyaltyPoints from '~/api/booking/paymentByLoyaltyPoints'
import * as checkstatus from '~/api/booking/checkstatus'
import * as prepareAccommodationBook from '~/api/accommodations/prepareAccommodationBook'
import * as book from '~/api/booking/book'
import * as exchangeRates from '~/api/exchangeRates/exchangeRates'
import * as manualExchangeRates from '~/api/manualExchangeRates/manualExchangeRates'
import * as manualExchangeRatesHistory from '~/api/manualExchangeRates/manualExchangeRatesHistory'
import * as companies from '~/api/companies/companies'
import * as companiesMassEdit from '~/api/companies/companiesMassEdit'
import * as downloadCompanies from '~/api/companies/downloadCompanies'
import * as generateKey from '~/api/companies/generateKey'
import * as companiesSettings from '~/api/companies/settings'
import * as companyRegistration from '~/api/companies/companyRegistration'
import * as companyRegistrationRequestActivate from '~/api/companies/companyRegistrationRequestActivate.js'
import * as companyRegistrationRequestDelete from '~/api/companies/companyRegistrationRequestDelete.js'
import * as consortiums from '~/api/companies/consortiums'
import * as subConsortiums from '~/api/companies/subConsortiums'
import * as offices from '~/api/companies/offices'
import * as tariffDetails from '~/api/accommodations/tariffDetails'
import * as onlinePaymentsInitiate from '~/api/onlinePayments/initiate'
import * as onlinePaymentsComplete from '~/api/onlinePayments/complete'
import * as onlinePayments from '~/api/onlinePayments/onlinePayments'
import * as onlinePaymentsReport from '~/api/onlinePayments/onlinePaymentsReport'
import * as onlinePaymentsProviders from '~/api/onlinePayments/onlinePaymentsProviders'
import * as searchAccommodationResults from '~/api/accommodations/searchAccommodationResults'
import * as popularDestinations from '~/api/cms/popularDestinations'
import * as popularHotels from '~/api/cms/popularHotels'
import * as blog from '~/api/cms/blog'
import * as topTours from '~/api/cms/topTours'
import * as layoutSettings from '~/api/cms/layoutSettings'
import * as infoPage from '~/api/cms/infoPage'
import * as resort from '~/api/cms/resort'
import * as resorts from '~/api/cms/resorts'
import * as persons from '~/api/persons/persons'
import * as departments from '~/api/persons/departments'
import * as availablePersonRoles from '~/api/persons/availablePersonRoles'
import * as downloadPersons from '~/api/persons/downloadPersons'
import * as orders from '~/api/orders/orders'
import * as orderDestinations from '~/api/orders/orderDestinations'
import * as orderDocumentsInfo from '~/api/orders/orderDocumentsInfo'
import * as customProductInfo from '~/api/orders/customProductInfo'
import * as orderFxGainLossDetailedInfo from '~/api/orders/orderFxGainLossDetailedInfo'
import * as currentOrderStatuses from '~/api/orders/currentOrderStatuses'
import * as orderItinerary from '~/api/orders/orderItinerary'
import * as downloadOrders from '~/api/orders/downloadOrders'
import * as modifyStatus from '~/api/orders/modifyStatus'
import * as manualModification from '~/api/orders/manualModification'
import * as itineraryKey from '~/api/orders/itineraryKey'
import * as travellerData from '@/api/orders/travellerData'
import * as orderServices from '@/api/orders/orderServices'
import * as massEditOrders from '@/api/orders/massEditOrders'
import * as ordersSummary from '@/api/orders/ordersSummary'
import * as orderHistory from '@/api/orders/orderHistory'
import * as orderHistoryOperations from '@/api/orders/orderHistoryOperations'
import * as orderCalculator from '@/api/orders/orderCalculator'
import * as orderClassificationTypes from '@/api/orders/orderClassificationTypes'
import * as loyaltyPoints from '@/api/orders/loyaltyPoints'
import * as serviceComments from '@/api/orders/serviceComments'
import * as airports from '~/api/locations/airports'
import * as cruisePorts from '~/api/locations/cruisePorts'
import * as voucher from '~/api/documents/voucher'
import * as seatMap from '~/api/documents/seatMap'
import * as itinerary from '~/api/documents/itinerary'
import * as download from '~/api/documents/download'
import * as additionalOptions from '~/api/accommodations/additionalOptions'
import * as suggestHotels from '~/api/accommodations/suggestHotels'
import * as updateCrmPerson from '~/api/crmperson/update'
import * as restoreB2BUserPasswordWithApiKey from '~/api/persons/restoreB2BUserPasswordWithApiKey'
import * as resetB2BUserPasswordWithApiKey from '~/api/persons/resetB2BUserPasswordWithApiKey'
import * as notificationTemplates from '~/api/notificationTemplates/notificationTemplates'
import * as emailNotificationTemplatePreview from '~/api/notificationTemplates/emailNotificationTemplatePreview'
import * as documentTemplates from '~/api/documentTemplates/documentTemplates'
import * as crmPersonPassport from '~/api/crmperson/passport'
import * as personPassport from '~/api/persons/passport'
import * as documents from '~/api/documents/documents'
import * as voidFlightTicket from '~/api/orders/voidFlightTicket'

import * as fillTransferBookingData from '~/api/transfers/fillTransferBookingData'
import * as searchTransfer from '~/api/transfers/searchTransfer'
import * as transferInfo from '~/api/transfers/transferInfo'
import * as vehicleType from '~/api/transfers/vehicleType'
import * as prepareBookTransfer from '~/api/transfers/prepareBookTransfer'
import * as trainStations from '~/api/locations/trainStations'
import * as transferAdditionalOptions from '~/api/transfers/transferAdditionalOptions'
import * as searchTransfersResults from '~/api/transfers/searchTransfersResults'

import * as searchActivities from '~/api/activities/searchActivities'
import * as prepareActivityBook from '~/api/activities/prepareActivityBook'
import * as activityInfo from '~/api/activities/activityInfo'
import * as excursionCategories from '~/api/activities/excursionCategories'
import * as excursionDescriptionTypes from '~/api/activities/excursionDescriptionTypes'
import * as excursions from '~/api/activities/excursions'
import * as corporatePolicyViolationCode from '~/api/corporatePolicyViolationCodes/corporatePolicyViolationCode'
import * as activityAdditionalOptions from '~/api/activities/activityAdditionalOptions'
import * as fillActivityBookingData from '~/api/activities/fillActivityBookingData'

import * as tourInfo from '~/api/tour/tourInfo'
import * as searchTours from '~/api/tour/searchTours'
import * as tourAdditionalOptions from '~/api/tour/tourAdditionalOptions'
import * as prepareBookTour from '~/api/tour/prepareBookTour'

import * as searchFlight from '~/api/flights/searchFlight'
import * as flightInfo from '~/api/flights/flightInfo'
import * as flightSeatsMap from '~/api/flights/flightSeatsMap'
import * as flightFareOptions from '~/api/flights/flightFareOptions'
import * as airlines from '~/api/flights/airlines'
import * as prepareFlightBook from '~/api/flights/prepareFlightBook'
import * as flightFares from '~/api/flights/flightFares'
import * as searchFlightSchedule from '~/api/flights/searchFlightSchedule'
import * as checkFlightPricesAndAvailability from '~/api/flights/checkFlightPricesAndAvailability'
import * as additionalFlightOptions from '~/api/flights/additionalFlightOptions'
import * as issueFlightTicket from '~/api/flights/issueFlightTicket'
import * as flightPreferences from '~/api/flights/flightPreferences'
import * as fillFlightBookingData from '~/api/flights/fillFlightBookingData'

import * as report from '~/api/reports/report'
import * as reportParameters from '~/api/reports/reportParameters'
import * as reportsList from '~/api/reports/reportsList'
import * as salesSettings from '~/api/contracts/salesSettings'
import * as supplierContract from '~/api/contracts/supplierContract'
import * as pricingRules from '~/api/contracts/pricingRules'
import * as contractGroups from '~/api/contracts/contractGroups'
import * as contractGroup from '~/api/contracts/contractGroup'
import * as companyContract from '~/api/contracts/companyContract'
import * as downloadStatementOfAccount from '~/api/reports/downloadStatementOfAccount'

import * as packageTourInfo from '~/api/package/packageTourInfo'
import * as packageTours from '~/api/package/packageTours'
import * as packagePrograms from '~/api/package/packagePrograms'
import * as preparePackageTourBook from '~/api/package/preparePackageTourBook'
import * as searchPackageTours from '~/api/package/searchPackageTours'
import * as updatePackageTourPrice from '~/api/package/updatePackageTourPrice'

import * as invoices from '~/api/invoices/invoices'
import * as printInvoice from '~/api/invoices/printInvoice'
import * as printRevise from '~/api/invoices/printRevise'
import * as invoiceIssueInfo from '~/api/invoices/invoiceIssueInfo'
import * as issueInvoice from '~/api/invoices/issueInvoice'
import * as issueBulkManualInvoices from '~/api/invoices/issueBulkManualInvoices'
import * as issueBulkInvoices from '~/api/invoices/issueBulkInvoices'
import * as invoicePaymentMethods from '~/api/invoices/invoicePaymentMethods'
import * as invoicePaymentByKey from '~/api/invoices/invoicePaymentByKey'
import * as manualInvoiceIssueInfo from '~/api/invoices/manualInvoiceIssueInfo'
import * as manualInvoicePaymentMethods from '~/api/invoices/manualInvoicePaymentMethods'
import * as issueManualInvoice from '~/api/invoices/issueManualInvoice'
import * as manualInvoices from '~/api/invoices/manualInvoices'
import * as manualInvoicePaymentByKey from '~/api/invoices/manualInvoicePaymentByKey'
import * as cancelManualInvoice from '@/api/invoices/cancelManualInvoice'
import * as downloadManualInvoices from '@/api/invoices/downloadManualInvoices'

import * as contracts from '~/api/ownProducts/contracts'
import * as tariffs from '~/api/ownProducts/tariffs'
import * as ownProductExtraServices from '~/api/ownProducts/ownProductExtraServices'
import * as ownProductContractImages from '~/api/ownProducts/ownProductContractImages'
import * as ownProductPaxes from '~/api/ownProducts/ownProductPaxes'
import * as ownProductServiceCategories from '~/api/ownProducts/ownProductServiceCategories'
import * as ownProductExtraServiceCategories from '~/api/ownProducts/ownProductExtraServiceCategories'
import * as ownProductServices from '~/api/ownProducts/ownProductServices'
import * as productVariants from '~/api/ownProducts/productVariants'
import * as ownProductPriceLists from '~/api/ownProducts/ownProductPriceLists'
import * as ownProductSecondaryServices from '~/api/ownProducts/ownProductSecondaryServices'
import * as ownProductSecondaryServiceType from '~/api/ownProducts/ownProductSecondaryServiceType'
import * as ownProductTariffs from '~/api/ownProducts/ownProductTariffs'
import * as ownProductServiceType from '~/api/ownProducts/ownProductServiceType.js'
import * as ownProductPriceListExtras from '~/api/ownProducts/ownProductPriceListExtras'
import * as ownProductDiscounts from '~/api/ownProducts/ownProductDiscounts'
import * as ownProductCommissions from '~/api/ownProducts/ownProductCommissions'
import * as priceListCodes from '~/api/ownProducts/priceListCodes'
import * as priceListCalculationTypes from '~/api/ownProducts/priceListCalculationTypes'
import * as ownProductContractFiles from '~/api/ownProducts/ownProductContractFiles'
import * as ownProductPenalties from '~/api/ownProducts/ownProductPenalties'
import * as ownProductPriceListSurcharges from '~/api/ownProducts/ownProductPriceListSurcharges'
import * as touristBookingFields from '~/api/booking/touristBookingFields'
import * as productBookingFields from '~/api/booking/productBookingFields'

import * as prepareAccommodationModify from '~/api/accommodations/prepareAccommodationModify'
import * as modifyAccommodationService from '~/api/accommodations/modifyAccommodationService'

import * as basket from '~/api/basket/basket'

import * as searchOwnExtraService from '~/api/ownExtraServices/searchOwnExtraService'
import * as ownExtraServiceInfo from '~/api/ownExtraServices/ownExtraServiceInfo'
import * as prepareOwnExtraServiceBook from '~/api/ownExtraServices/prepareOwnExtraServiceBook'
import * as ownExtraServiceAdditionalOptions from '~/api/ownExtraServices/ownExtraServiceAdditionalOptions'

import * as availability from '~/api/ownProducts/availability'
import * as subAllotments from '~/api/ownProducts/subAllotments'
import * as channelManagers from '~/api/accommodationContracts/channelManagers'
import * as channelManagersConfig from '~/api/accommodationContracts/channelManagersConfig'
import * as channelManagerSynchronization from '~/api/accommodationContracts/channelManagerSynchronization'
import * as dailyRates from '~/api/accommodationContracts/dailyRates'
import * as ownAccommodationContracts from '~/api/accommodationContracts/ownAccommodationContracts'
import * as accommodationExtraServices from '~/api/accommodationContracts/accommodationExtraServices'
import * as accommodationExtraServiceCategory from '~/api/accommodationContracts/accommodationExtraServiceCategory'
import * as ownHotelSecondaryServices from '~/api/accommodationContracts/ownHotelSecondaryServices'
import * as ownHotelServices from '~/api/accommodationContracts/ownHotelServices'
import * as prices from '~/api/ownProducts/prices'

import * as messages from '~/api/onlineChat/messages'
import * as message from '~/api/onlineChat/message'
import * as markReadCount from '~/api/onlineChat/markReadCount'

import * as tickets from '~/api/tickets/tickets'
import * as ticketMessages from '~/api/tickets/ticketMessages'

import * as searchCarRent from '~/api/carRent/searchCarRent'
import * as prepareCarBook from '~/api/carRent/prepareCarBook'
import * as additionalCarRentOptions from '~/api/carRent/additionalCarRentOptions'
import * as carRentInfo from '~/api/carRent/carRentInfo'
import * as carBookingData from '~/api/carRent/carBookingData'
import * as fillCarBookingData from '~/api/carRent/fillCarBookingData'
import * as pointInfo from '~/api/carRent/pointInfo'

import * as ownCarRentContracts from '~/api/carRentContracts/ownCarRentContracts'
import * as carRentExtraServices from '~/api/carRentContracts/carRentExtraServices'
import * as ownExcursionContracts from '~/api/excursionContracts/ownExcursionContracts'
import * as ownExcursionServices from '~/api/excursionContracts/ownExcursionServices'
import * as ownExcursionServiceCategories from '~/api/excursionContracts/ownExcursionServiceCategories'
import * as ownCharterContracts from '~/api/charterContracts/ownCharterContracts'
import * as charterExtraServices from '~/api/charterContracts/charterExtraServices'
import * as ownCharterServiceCategories from '~/api/charterContracts/ownCharterServiceCategories'
import * as ownCharterServices from '~/api/charterContracts/ownCharterServices'
import * as ownTransferContracts from '~/api/transferContracts/ownTransferContracts'
import * as ownTransferServices from '~/api/transferContracts/ownTransferServices'
import * as ownTransferServiceCategories from '~/api/transferContracts/ownTransferServiceCategories'
import * as ownExtraServiceContracts from '~/api/extraServiceContracts/ownExtraServiceContracts'
import * as ownExtraServicePriceLists from '~/api/extraServiceContracts/ownExtraServicePriceLists'
import * as ownEventContracts from '~/api/eventContracts/ownEventContracts'
import * as venues from '~/api/locations/venues'
import * as ownCruiseContracts from '~/api/cruiseContracts/ownCruiseContracts'
import * as shipContent from '~/api/cruiseContracts/shipContent'
import * as ownVisaContracts from '~/api/visaContracts/ownVisaContracts'
import * as ownVisaCustomFieldsList from '~/api/visaContracts/ownVisaCustomFieldsList'
import * as ownVisaCustomFields from '~/api/visaContracts/ownVisaCustomFields'
import * as ownTourContracts from '~/api/tourContracts/ownTourContracts'
import * as ownTourContractsItineraryDay from '~/api/tourContracts/ownTourContractsItineraryDay'
import * as ownTourContractsAccommodation from '~/api/tourContracts/ownTourContractsAccommodation'
import * as ownInsuranceContracts from '~/api/insuranceContracts/ownInsuranceContracts'
import * as ownInsuranceServices from '~/api/insuranceContracts/ownInsuranceServices'
import * as ownPackageContracts from '~/api/packageContracts/ownPackageContracts'
import * as ownPackageContractsItineraryDay from '~/api/packageContracts/ownPackageContractsItineraryDay'
import * as ownPackageContractsItineraryDaySwap from '~/api/packageContracts/ownPackageContractsItineraryDaySwap'
import * as ownPackageContractsItinerary from '~/api/packageContracts/ownPackageContractsItinerary'
import * as ownPackageContractsAvailability from '~/api/packageContracts/ownPackageContractsAvailability'

import * as searchInsurance from '~/api/insurance/searchInsurance'
import * as prepareInsuranceBook from '~/api/insurance/prepareInsuranceBook'

import * as searchVisa from '~/api/visa/searchVisa'
import * as prepareVisaBook from '~/api/visa/prepareVisaBook'

import * as schedulerGroups from '~/api/scheduler/schedulerGroups'
import * as seatsByProcessId from '~/api/scheduler/seatsByProcessId'
import * as downloadSchedulerGroups from '~/api/scheduler/downloadSchedulerGroups'
import * as downloadSchedulerGroupsDetails from '~/api/scheduler/downloadSchedulerGroupsDetails'
import * as schedulerGroupDetails from '~/api/scheduler/schedulerGroupDetails'
import * as schedulerGroupPresence from '~/api/scheduler/schedulerGroupPresence'
import * as modifySchedulerGroup from '~/api/scheduler/modifySchedulerGroup'

import * as tips from '~/api/orders/tips'

import * as communications from '~/api/crmCommunications/communications.js'
import * as campaigns from '~/api/crmCampaigns/campaigns.js'
import * as visaInfo from '~/api/visa/visaInfo'

import * as wishlist from '~/api/b2c/wishlist'
import * as recentViews from '~/api/b2c/recentViews'
import * as tripAssistant from '~/api/b2c/tripAssistant.js'
import * as paymentsPageSelection from '~/api/b2c/paymentsPageSelection'
import * as mail from '~/api/b2c/mail'
import * as reservationReportMail from '~/api/b2c/reservationReportMail'
import * as atolCertificate from '~/api/b2c/atolCertificate'
import * as reservationsTableOptions from '~/api/b2c/reservationsTableOptions'
import * as clientsTableOptions from '~/api/b2c/clientsTableOptions'
import * as customFilters from '~/api/b2c/customFilters'
import * as companiesCustomFilters from '~/api/b2c/companiesCustomFilters'
import * as customDocsCounter from '~/api/b2c/customDocsCounter'
import * as reservationsFiltersConfiguration from '~/api/b2c/reservationsFiltersConfiguration'
import * as customDocuments from '~/api/b2c/customDocuments'

import * as searchCruises from '~/api/cruises/searchCruises'
import * as cruiseInfo from '~/api/cruises/cruiseInfo'
import * as prepareBookCruise from '~/api/cruises/prepareBookCruise'
import * as cruiseAdditionalOptions from '~/api/cruises/cruiseAdditionalOptions'
import * as fillCruiseBookingData from '~/api/cruises/fillCruiseBookingData'

import * as addOns from '~/api/orders/addOns'
import * as confirmPrebooking from '~/api/orders/confirmPrebooking'

import * as transactions from '~/api/uploads/transactions'

import * as salesMonitoringReport from '~/api/businessIntelligence/salesMonitoringReport'
import * as detailedSalesMonitoringReport from '~/api/businessIntelligence/detailedSalesMonitoringReport'
import * as kpiStatistics from '~/api/businessIntelligence/kpiStatistics'
import * as kpi from '~/api/businessIntelligence/kpi'

import * as reviews from '~/api/reviewsAndFeedback/reviews'
import * as addReviewFromEmail from '~/api/reviewsAndFeedback/addReviewFromEmail'
import * as serviceReviews from '~/api/reviewsAndFeedback/serviceReviews'
import * as checkServiceReviews from '~/api/reviewsAndFeedback/checkServiceReviews'

import * as dashboards from '~/api/dashboards/dashboards'
import * as organizationFinances from '~/api/dashboards/organizationFinances'

import * as inboundEmails from '~/api/b2c/inboundEmails'

import * as importCorporateClients from '~/api/import/importCorporateClients'
import * as importOrganisations from '~/api/import/importOrganisations'
import * as importSupplierCredentials from '~/api/import/importSupplierCredentials'
import * as importUsers from '~/api/import/importUsers'

import * as pspSettings from '~/api/PSPSettings/pspSettings'
import * as pspSettingsConditions from '~/api/PSPSettings/pspSettingsConditions'

//TODO Separate cms api from gpts api
import * as cmsAuth from '~/api/cms/cmsAuth'
import * as homePageSettings from '~/api/cms/homePageSettings'

//Google API
import * as geocode from '~/api/google/geocode'
import * as placeAutocomplete from '~/api/google/placeAutocomplete'

// openWeatherMap API
import * as weather from '~/api/openWeatherMap/weather'

// open AI
import * as chat from '~/api/openai/chat'
import * as assistants from '~/api/openai/assistants'
import * as threads from '~/api/openai/threads'
import * as threadsMessages from '~/api/openai/threadsMessages'
import * as threadsRuns from '~/api/openai/threadsRuns'
import * as assistantsFiles from '~/api/openai/assistantsFiles'
import * as files from '~/api/openai/files'

import * as searchDynamicPackages from '~/api/package/searchDynamicPackages'
import * as prepareDynamicPackageBook from '~/api/package/prepareDynamicPackageBook'
import * as updatePackagePrice from '~/api/package/updatePackagePrice'
import * as updatePackageOffers from '~/api/package/updatePackageOffers'

import * as privateClients from '~/api/crmperson/privateClients'
import * as suggestPrivateClients from '~/api/crmperson/suggestPrivateClients'
import * as privateClientsMassEdit from '@/api/crmperson/privateClientsMassEdit'
import * as membershipLevels from '@/api/crmperson/membershipLevels'
import * as prepareModifyService from '@/api/orders/prepareModifyService'
import * as modifyService from '@/api/orders/modifyService'

import * as vatPlans from '@/api/salesSettings/vatPlans'
import * as vatPlan from '@/api/salesSettings/vatPlan'
import * as loyalties from '@/api/salesSettings/loyalties'
import * as voucherSettings from '@/api/salesSettings/voucherSettings'
import * as loyalty from '@/api/salesSettings/loyalty'
import * as turOpConditions from '@/api/salesSettings/turOpConditions'
import * as discounts from '@/api/salesSettings/discounts'
import * as discount from '@/api/salesSettings/discount'
import * as salesItemTypes from '@/api/salesSettings/salesItemTypes'

import * as promoCode from '@/api/promoCode/promoCode'

import * as conditionItemTypes from '@/api/conditionsSettings/conditionItemTypes.js'
import * as valueTypeConditions from '@/api/conditionsSettings/valueTypeConditions.js'

import * as notificationSettingsPerson from '~/api/notificationSettings/notificationSettingsPerson.js'
import * as notificationSettingsCompany from '~/api/notificationSettings/notificationSettingsCompany.js'
import * as notificationSettingsMyCompany from '~/api/notificationSettings/notificationSettingsMyCompany.js'
import * as notificationSettingsMyCompanyClients from '~/api/notificationSettings/notificationSettingsMyCompanyClients.js'

import {downloadData} from '@/utils/helpers'
import {appInstance} from '@/utils/app-accessor'

const getFilename = response => {
    const disposition = response.headers['content-disposition']
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) {
            return decodeURI(matches[1].replace(/['"]/g, '')).replace('UTF-8', '')
        }
    }
    return ''
}

//TODO Setup routerBase for /api and /cms proxy
const setProxyBase = url =>
    appInstance.$conf.public.routerBase ? appInstance.$conf.public.routerBase.slice(0, -1) + url : url

export async function getMethod(url, request = {}, cancelToken, configParams) {
    const config = {
        params: request,
        ...configParams,
    }
    if (cancelToken) {
        config.cancelToken = cancelToken
    }
    return await axiosInstance.$get(setProxyBase(url), config)
}

export async function postMethod(url, request, config) {
    return await axiosInstance.$post(setProxyBase(url), request, config)
}

export async function deleteMethod(url, request = {}) {
    const config = {
        data: request,
    }
    return await axiosInstance.delete(setProxyBase(url), config)
}

export async function putMethod(url, request, config) {
    return (await axiosInstance.put(setProxyBase(url), request, config)).data
}

export async function patchMethod(url, request, config) {
    return (await axiosInstance.patch(setProxyBase(url), request, config)).data
}

export async function getFile(url, request, filename) {
    const rs = await axiosInstance.get(setProxyBase(url), {
        params: request,
        responseType: 'blob',
    })
    downloadData(rs.data, filename || getFilename(rs))
}

export async function postFile(url, request, filename) {
    const rs = await axiosInstance.post(setProxyBase(url), request, {
        responseType: 'blob',
    })
    downloadData(rs.data, filename || getFilename(rs))
}

export async function getBase(url, params = {}, cancelToken) {
    return await axiosBaseInstance.$get(url, {
        params,
        ...(cancelToken && {cancelToken}),
    })
}

export default {
    authorization,
    aspOption,
    authorizationInfo,
    getUserInfoByToken,
    registration,
    restorePassword,
    locations,
    locationPoints,
    restrictedLocations,
    contentProvidersLocations,
    searchAccommodation,
    partialSearchResults,
    partialSearchStatus,
    suppliers,
    contentProviders,
    hotelInfo,
    hotelDictionaryInfo,
    hotelChainDictionaryInfo,
    hotelServiceDictionaryInfo,
    hotelRoomDictionaryInfo,
    hotelRoomAmenitiesTypes,
    hotelRoomAmenities,
    hotelTags,
    hotels,
    conditions,
    cancelService,
    currentCancelInfo,
    paymentOptions,
    prepareBookSaveOrder,
    paymentMethods,
    paymentByLoyaltyPoints,
    checkstatus,
    prepareAccommodationBook,
    book,
    exchangeRates,
    manualExchangeRates,
    manualExchangeRatesHistory,
    companies,
    companiesMassEdit,
    downloadCompanies,
    generateKey,
    companiesSettings,
    companyRegistration,
    companyRegistrationRequestDelete,
    companyRegistrationRequestActivate,
    consortiums,
    subConsortiums,
    offices,
    tariffDetails,
    onlinePaymentsInitiate,
    onlinePaymentsComplete,
    onlinePayments,
    onlinePaymentsReport,
    onlinePaymentsProviders,
    searchAccommodationResults,
    popularDestinations,
    popularHotels,
    layoutSettings,
    infoPage,
    resort,
    resorts,
    persons,
    departments,
    availablePersonRoles,
    downloadPersons,
    orders,
    orderDestinations,
    orderDocumentsInfo,
    currentOrderStatuses,
    orderItinerary,
    downloadOrders,
    airports,
    cruisePorts,
    voucher,
    seatMap,
    itinerary,
    download,
    additionalOptions,
    suggestHotels,
    updateCrmPerson,
    fillTransferBookingData,
    searchTransfer,
    transferInfo,
    vehicleType,
    prepareBookTransfer,
    searchActivities,
    prepareActivityBook,
    trainStations,
    activityInfo,
    excursionCategories,
    excursionDescriptionTypes,
    excursions,
    tourInfo,
    searchTours,
    tourAdditionalOptions,
    prepareBookTour,
    restoreB2BUserPasswordWithApiKey,
    resetB2BUserPasswordWithApiKey,
    resetPassword,
    corporatePolicyViolationCode,
    notificationTemplates,
    emailNotificationTemplatePreview,
    documentTemplates,
    searchFlight,
    flightInfo,
    flightSeatsMap,
    flightFareOptions,
    airlines,
    prepareFlightBook,
    flightFares,
    cmsAuth,
    homePageSettings,
    searchDynamicPackages,
    prepareDynamicPackageBook,
    updatePackagePrice,
    updatePackageOffers,
    searchFlightSchedule,
    checkFlightPricesAndAvailability,
    additionalFlightOptions,
    privateClients,
    suggestPrivateClients,
    privateClientsMassEdit,
    membershipLevels,
    report,
    reportParameters,
    reportsList,
    blog,
    topTours,
    packageTourInfo,
    packageTours,
    packagePrograms,
    preparePackageTourBook,
    searchPackageTours,
    updatePackageTourPrice,
    invoices,
    printInvoice,
    printRevise,
    invoiceIssueInfo,
    issueInvoice,
    issueBulkManualInvoices,
    issueBulkInvoices,
    invoicePaymentMethods,
    invoicePaymentByKey,
    manualInvoiceIssueInfo,
    manualInvoicePaymentByKey,
    issueManualInvoice,
    manualInvoices,
    manualInvoicePaymentMethods,
    cancelManualInvoice,
    downloadManualInvoices,
    contracts,
    tariffs,
    ownProductContractImages,
    ownProductExtraServices,
    ownProductPaxes,
    ownProductServiceCategories,
    ownProductExtraServiceCategories,
    ownProductServices,
    productVariants,
    ownProductPriceLists,
    ownProductSecondaryServices,
    ownProductSecondaryServiceType,
    ownProductTariffs,
    ownProductServiceType,
    ownProductPriceListExtras,
    ownProductDiscounts,
    ownProductCommissions,
    priceListCodes,
    priceListCalculationTypes,
    ownProductContractFiles,
    ownProductPenalties,
    ownProductPriceListSurcharges,
    touristBookingFields,
    ownExtraServiceInfo,
    prepareAccommodationModify,
    modifyAccommodationService,
    searchOwnExtraService,
    prepareOwnExtraServiceBook,
    ownExtraServiceAdditionalOptions,
    issueFlightTicket,
    activityAdditionalOptions,
    transferAdditionalOptions,
    searchTransfersResults,
    crmPersonPassport,
    personPassport,
    b2c,
    b2cSettings,
    b2cKey,
    b2cPaymentMethods,
    settings,
    reportIssueInfo,
    modifyStatus,
    itineraryKey,
    availability,
    subAllotments,
    channelManagers,
    channelManagersConfig,
    channelManagerSynchronization,
    dailyRates,
    ownAccommodationContracts,
    accommodationExtraServices,
    accommodationExtraServiceCategory,
    ownHotelSecondaryServices,
    ownHotelServices,
    prices,
    downloadStatementOfAccount,
    messages,
    message,
    markReadCount,
    tickets,
    ticketMessages,
    flightPreferences,
    searchCarRent,
    carRentInfo,
    carBookingData,
    pointInfo,
    prepareCarBook,
    additionalCarRentOptions,
    geocode,
    placeAutocomplete,
    prepareInsuranceBook,
    searchInsurance,
    searchVisa,
    prepareVisaBook,
    travellerData,
    manualModification,
    documents,
    voidFlightTicket,
    basket,
    weather,
    visaInfo,
    schedulerGroups,
    seatsByProcessId,
    downloadSchedulerGroups,
    downloadSchedulerGroupsDetails,
    schedulerGroupDetails,
    schedulerGroupPresence,
    modifySchedulerGroup,
    orderServices,
    massEditOrders,
    ordersSummary,
    orderHistory,
    orderHistoryOperations,
    orderCalculator,
    orderClassificationTypes,
    loyaltyPoints,
    tips,
    communications,
    campaigns,
    wishlist,
    recentViews,
    tripAssistant,
    paymentsPageSelection,
    mail,
    reservationReportMail,
    atolCertificate,
    searchCruises,
    cruiseInfo,
    prepareBookCruise,
    cruiseAdditionalOptions,
    reservationsTableOptions,
    clientsTableOptions,
    customFilters,
    companiesCustomFilters,
    customDocsCounter,
    reservationsFiltersConfiguration,
    fillAccommodationBookingData,
    hotelDescriptionCheckin,
    hotelCategoryDictionaryInfo,
    hotelTypesDictionaryInfo,
    hotelDescriptionLocation,
    ownHotelInfo,
    copyHotelInfo,
    hotelDescriptionAmenities,
    hotelExtraServicesDictionaryInfo,
    hotelClassificationDictionaryInfo,
    hotelDescriptionGeneral,
    hotelDescriptionDetails,
    hotelDescriptionMealType,
    hotelDescriptionImages,
    hotelMealTypesDictionaryInfo,
    hotelDescriptionRoomType,
    hotelDescriptionRoomTypeSwap,
    hotelLocationDictionaryInfo,
    fillActivityBookingData,
    fillFlightBookingData,
    fillCruiseBookingData,
    fillCarBookingData,
    customDocuments,
    addOns,
    confirmPrebooking,
    productBookingFields,
    orderFxGainLossDetailedInfo,
    transactions,
    prepareModifyService,
    modifyService,
    serviceComments,
    ownCarRentContracts,
    carRentExtraServices,
    ownExcursionContracts,
    ownExcursionServices,
    ownExcursionServiceCategories,
    ownCharterContracts,
    charterExtraServices,
    ownCharterServiceCategories,
    ownCharterServices,
    ownTransferContracts,
    ownTransferServices,
    ownTransferServiceCategories,
    ownExtraServiceContracts,
    ownExtraServicePriceLists,
    ownEventContracts,
    venues,
    ownCruiseContracts,
    shipContent,
    ownVisaContracts,
    ownVisaCustomFieldsList,
    ownVisaCustomFields,
    ownTourContracts,
    ownTourContractsItineraryDay,
    ownTourContractsAccommodation,
    ownInsuranceContracts,
    ownInsuranceServices,
    ownPackageContracts,
    ownPackageContractsItineraryDay,
    ownPackageContractsItineraryDaySwap,
    ownPackageContractsItinerary,
    ownPackageContractsAvailability,
    salesMonitoringReport,
    detailedSalesMonitoringReport,
    kpiStatistics,
    kpi,
    customProductInfo,
    salesSettings,
    supplierContract,
    pricingRules,
    reviews,
    dashboards,
    organizationFinances,
    addReviewFromEmail,
    serviceReviews,
    checkServiceReviews,
    chat,
    assistants,
    threads,
    threadsMessages,
    threadsRuns,
    assistantsFiles,
    files,
    inboundEmails,
    importCorporateClients,
    importOrganisations,
    importSupplierCredentials,
    importUsers,
    contractGroups,
    contractGroup,
    companyContract,
    vatPlans,
    vatPlan,
    loyalties,
    voucherSettings,
    loyalty,
    turOpConditions,
    discounts,
    discount,
    salesItemTypes,
    notificationSettingsPerson,
    notificationSettingsCompany,
    notificationSettingsMyCompanyClients,
    notificationSettingsMyCompany,
    pspSettings,
    pspSettingsConditions,
    promoCode,
    conditionItemTypes,
    valueTypeConditions,
}
